const es = {
  // Navegación
  "nav.home": "Inicio",
  "nav.about": "Acerca de",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Actualizaciones",
  "nav.fwb": "FWB",
  "nav.tokensale": "Venta de Tokens",
  
  // Secciones comunes
  "common.learnMore": "Saber más",
  "common.buyNow": "Comprar ahora",
  "common.contactUs": "Contáctanos",
  "common.loading": "Cargando",
  
  // Página inicial
  "home.hero.title": "La evolución de los pagos digitales",
  "home.hero.subtitle": "eDOP Token: El token de utilidad para el ecosistema financiero de República Dominicana",
  "home.hero.cta": "Participar en la preventa",
  
  // Acerca de
  "about.title": "Sobre eDOP Token",
  "about.description": "eDOP Token es un token digital diseñado para revolucionar los pagos en República Dominicana",
  
  // Tokenomics
  "tokenomics.title": "Distribución de Tokens",
  "tokenomics.supply": "Suministro total",
  
  // Página de Tokenomics
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "Distribución y Economía del Token eDOP",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Contenido: El token eDOP tiene un suministro total fijo de 1 mil millones de unidades (1.000.000.000 eDOP). Su diseño económico incluye una distribución estratégica para incentivar la participación temprana, recompensar a los usuarios a largo plazo a través del staking, asegurar la liquidez en el mercado y financiar el desarrollo continuo y la adopción del ecosistema.",
  
  "tokenomics.distribution.title": "Distribución del Token",
  "tokenomics.distribution.content": "El suministro total de 1 mil millones de eDOP se asigna de la siguiente manera:",
  "tokenomics.distribution.items": [
    "40% Preventa pública: Para los primeros adoptantes.",
    "30% Recompensas de Staking: Distribuido durante 2 años para recompensar a los tenedores.",
    "10% Liquidez: Bloqueada por un mínimo de 10 años o a perpetuidad para estabilidad.",
    "10% Marketing y adopción: Para crecimiento y difusión.",
    "5% Desarrollo: Con liberación gradual para el equipo (vesting).",
    "5% Inventarios de Cadena: Para operaciones técnicas del ecosistema."
  ],
  
  "tokenomics.purpose.title": "eDOP: Un Token con Propósito",
  "tokenomics.purpose.content": "Con un suministro total limitado a 1 mil millones de unidades, el token eDOP está diseñado para ser útil y sostenible. Su distribución estratégica asegura fondos para recompensas de staking (30%), liquidez a largo plazo (10%) y crecimiento. Principalmente, puedes usar eDOP como un medio de pago eficiente y de bajo costo, o bloquearlo (staking) para obtener recompensas y beneficios adicionales dentro de nuestro ecosistema financiero digital.",
  
  "tokenomics.utility.title": "Utilidad del Token",
  "tokenomics.utility.items": [
    "Gobernanza: Los poseedores de eDOP pueden votar en propuestas clave que afectan el desarrollo y dirección del proyecto.",
    "Staking: Obtén recompensas significativas al hacer staking de tus tokens, con tasas anuales competitivas.",
    "Tarifas Reducidas: Los usuarios que poseen eDOP disfrutan de tarifas reducidas en todas las transacciones dentro de la plataforma.",
    "Acceso a Características Exclusivas: Desbloquea funcionalidades avanzadas y herramientas dentro de nuestra plataforma.",
    "Medio de Pago: Utiliza eDOP para transacciones rápidas y económicas dentro de nuestro ecosistema."
  ],
  
  // Venta de tokens
  "tokensale.title": "Venta de Tokens",
  "tokensale.subtitle": "Participa en nuestra preventa",
  "tokensale.price": "Precio actual",
  "tokensale.connect": "Conectar billetera",
  
  // Footer
  "footer.rights": "Todos los derechos reservados",
  "footer.terms": "Términos y condiciones",
  "footer.privacy": "Política de privacidad",
  "footer.fwb": "Amigos con Beneficios",
  
  // Wallet
  "wallet.connect": "Conectar Wallet",
  
  // Noticias
  "news.label": "NOTICIAS",
  
  // Burbujas de la página Home
  "bubbles.home.revolution.title": "eDOP: Revolución del Mercado",
  "bubbles.home.revolution.content": "El token eDOP tiene como objetivo proporcionar una alternativa digital eficiente y accesible en el ecosistema de criptomonedas, con enfoque inicial en mercados emergentes y una visión de adopción global.",
  
  "bubbles.home.ecosystem.title": "El Ecosistema eDOP",
  "bubbles.home.ecosystem.content": "No te pierdas la oportunidad de formar parte de la próxima generación de soluciones blockchain del mundo cripto.",
  
  // Botones y textos adicionales
  "cta.whitepaper": "Libro Blanco",
  "home.title": "eDOP: Revolución Digital",
  
  // Página About - Burbujas
  "bubbles.about.edop.title": "Acerca de eDOP",
  "bubbles.about.edop.content": "eDOP es una alternativa digital eficiente y accesible en el ecosistema cripto, diseñada para abordar problemas de acceso financiero, especialmente en mercados emergentes. Integra facilidad de uso con seguridad, buscando una adopción global.",
  
  "bubbles.about.mission.title": "Nuestra Misión",
  "bubbles.about.mission.content": "Democratizar el acceso a los servicios financieros digitales, ofreciendo herramientas accesibles que permitan a las personas tomar control de sus finanzas sin intermediarios costosos.",
  
  "bubbles.about.transparency.title": "Transparencia",
  "bubbles.about.transparency.content": "Todas las operaciones quedan registradas de forma inmutable en la blockchain, garantizando transparencia absoluta. Además, nos comprometemos a publicar los resultados de las auditorías de seguridad para generar confianza.",
  
  "bubbles.about.innovation.title": "Innovación",
  "bubbles.about.innovation.content": "Innovamos al ofrecer una solución cripto centrada en el usuario para la inclusión financiera, con un ecosistema que incluye pagos de bajo costo, incentivos, y futuros desarrollos como un DEX propio y una aplicación móvil.",
  
  "bubbles.about.community.title": "Comunidad",
  "bubbles.about.community.content": "Fomentamos una comunidad comprometida a través de un sistema de incentivos que recompensa la participación, el staking y el uso activo del ecosistema, buscando una distribución equilibrada y la expansión de nuestra base de usuarios.",
  
  "bubbles.about.team.title": "Nuestro Equipo",
  "bubbles.about.team.content": "Contamos con un equipo multidisciplinario con amplia experiencia en finanzas digitales, desarrollo blockchain y mercados emergentes, respaldado por asesores estratégicos en áreas clave como regulación y economía",
  
  "bubbles.about.technology.title": "Nuestra Tecnología",
  "bubbles.about.technology.content": "eDOP es un token BEP-20 que opera sobre la BNB Smart Chain (BSC), elegida por su equilibrio óptimo entre velocidad, seguridad y costos accesibles, utilizando smart contracts desarrollados bajo las mejores prácticas.",
  
  "bubbles.about.speed.title": "Velocidad",
  "bubbles.about.speed.content": "Gracias a la BNB Smart Chain, las transacciones con eDOP Token se confirman rápidamente, típicamente entre 3 y 15 segundos, ofreciendo una eficiencia superior a los sistemas tradicionales y otras blockchains.",
  
  "bubbles.about.lowcost.title": "Bajo Costo",
  "bubbles.about.lowcost.content": "eDOP ofrece comisiones drásticamente reducidas, situándose entre 0% y 1% por transacción, en comparación con el 5% al 10% de las remesadoras tradicionales. Esto se logra mediante el uso de la eficiente red BNB Smart Chain, contratos inteligentes optimizados y la eliminación de intermediarios, permitiendo transacciones asequibles, incluso para micropagos.",
  
  "bubbles.about.security.title": "Seguridad y Contacto",
  "bubbles.about.security.content": "La seguridad es prioritaria, implementando contratos auditado por firmas reconocidas, herramientas probadas (OpenZeppelin), sistemas multi-firma y monitoreo constante. Para consultas, contáctanos en info@edoptoken.com, admin@edoptoken.com o a través de nuestras redes sociales oficiales puplicadas nuestro sitio web.",
  
  "about.page.title": "Acerca de Nosotros",
  
  // Página Política de Privacidad - Título
  "privacy.page.title": "Política de Privacidad",
  
  // Página Política de Privacidad - Burbujas
  "bubbles.privacy.commitment.title": "Compromiso con tu Privacidad",
  "bubbles.privacy.commitment.content": "En eDOP Token, nos comprometemos con la transparencia total y la protección de tus datos. Como proyecto centrado en la democratización del acceso a servicios financieros digitales, entendemos la importancia de la confianza.",
  
  "bubbles.privacy.nocollection.title": "No Recopilamos Información",
  "bubbles.privacy.nocollection.content": "Para cumplir con nuestra misión de inclusión financiera, nunca solicitamos ni pedimos datos de identificación, evita ser victima de phishing y nunca releve tus claves privadas o tus frases semillas, nunca eDOP Token te las solicitará, recuérdalo.",
  
  "bubbles.privacy.usage.title": "Cómo usamos tu información",
  "bubbles.privacy.usage.content": "No recopilamos datos personales o alguna información. Solo usamos tu dirección de wallet para operar, datos técnicos para mantener la seguridad de la plataforma y, de forma opcional, algunos detalles que mejoran tu experiencia. Todo bajo buenas prácticas y sin compartir información con terceros.",
  
  "bubbles.privacy.security.title": "Seguridad y protección",
  "bubbles.privacy.security.content": "Aplicamos las mismas medidas de seguridad que protegen nuestros smart contracts: protocolos de OpenZeppelin, multifirma en operaciones clave, límites para reducir riesgos y monitoreo constante. Todo está alineado con nuestras auditorías, garantizando la seguridad de tus datos y activos digitales.",
  
  // Página FWB (Amigos con Beneficios)
  "fwb.page.title": "Amigos con Beneficios (FWB)",
  
  // Burbujas de la página FWB
  "bubbles.fwb.community.title": "Comunidad eDOP (FWB)",
  "bubbles.fwb.community.content": "En eDOP, creemos en una comunidad global que busca democratizar el acceso financiero. Nuestro ecosistema está diseñado para que los usuarios tomen el control y colaboren hacia una economía digital más equitativa, especialmente en mercados emergentes.",
  
  "bubbles.fwb.join.title": "Cómo Unirse y Participar",
  "bubbles.fwb.join.content": "Forma parte activa de eDOP usando el token para pagos, participando en nuestro programa de staking para apoyar la red, y preparándote para contribuir en la futura gobernanza del ecosistema. Tu participación es clave para nuestro crecimiento.",
  "bubbles.fwb.join.date": "Fecha: 04 de abril de 2025",
  
  "bubbles.fwb.benefits.title": "Beneficios de la Comunidad eDOP",
  "bubbles.fwb.benefits.content": "Al participar en eDOP, puedes obtener recompensas periódicas a través del staking (provenientes del 30% del suministro total asignado). Además, la tenencia activa puede darte acceso a beneficios como descuentos en tarifas o prioridad en nuevas funciones del ecosistema.",
  
  "bubbles.fwb.connect.title": "Conéctate con la Comunidad",
  "bubbles.fwb.connect.content": "Mantente informado y conectado con el proyecto eDOP. Encuentra los enlaces a nuestros canales comunitarios oficiales, documentación técnica y formas de contacto directamente en nuestro sitio web oficial.",
  
  // Página de Términos y Condiciones
  "terms.page.title": "Términos y Condiciones",
  
  // Burbujas de la página de Términos
  "bubbles.terms.risk.title": "Advertencias de Riesgo:",
  "bubbles.terms.risk.content": "La inversión en eDOP Token implica riesgos importantes, incluyendo alta volatilidad y la posible pérdida total o parcial del capital. El valor del token depende del mercado, no hay garantía de rentabilidad y los activos digitales no cuentan con seguros de depósito. Considere cuidadosamente su tolerancia al riesgo antes de invertir.",
  
  "bubbles.terms.liability.title": "Limitación de Responsabilidad",
  "bubbles.terms.liability.content": "El rendimiento del eDOP Token está sujeto a riesgos de mercado fuera del control del emisor (Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL). No nos responsabilizamos por pérdidas derivadas de la volatilidad, fluctuaciones de liquidez o riesgos inherentes a la inversión en activos digitales.",
  
  "bubbles.terms.issuer.title": "Emisor y Cumplimiento Legal",
  "bubbles.terms.issuer.content": "eDOP Token es emitido por Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL, entidad legalmente constituida. Buscamos operar en cumplimiento con las regulaciones aplicables y contamos con asesoría legal en materia de activos digitales y derecho financiero.",
  
  "bubbles.terms.contact.title": "Contacto",
  "bubbles.terms.contact.content": "Para consultas relacionadas con estos términos, el proyecto eDOP Token o para más información, puede dirigirse a nuestro Correo Electrónico: o consultar los recursos adicionales en nuestro Sitio Web.",
  
  // Página de Actualizaciones de Desarrollo
  "devupdates.page.title": "Actualizaciones de Desarrollo",
  
  // Burbujas de la página de Actualizaciones de Desarrollo
  "bubbles.devupdates.intro.title": "Actualizaciones de Desarrollo",
  "bubbles.devupdates.intro.content": "Según el plan técnico descrito en el whitepaper, el desarrollo de eDOP se centra en la creación de componentes clave como una plataforma de pagos de bajo costo, un futuro exchange descentralizado propio (DEX) y una aplicación móvil. Todo el ecosistema está diseñado para operar sobre la BNB Smart Chain, buscando un equilibrio entre eficiencia, seguridad y accesibilidad.",
  
  "bubbles.devupdates.latest.title": "Últimas Actualizaciones",
  "bubbles.devupdates.latest.content": "Basados en el plan original del whitepaper y preparándonos para nuestra Fase 1 (estimada para finales de Q2 2025), nuestro enfoque actual incluye los preparativos del lanzamiento del token, la activación de la plataforma de pagos y asegurar los listados iniciales en exchanges. Para conocer el progreso real y los anuncios confirmados, por favor consulta siempre nuestros canales oficiales.",
  "bubbles.devupdates.latest.date": "Fecha: 28 de abril de 2025",
  
  "bubbles.devupdates.events.title": "Próximos Eventos Comunitarios",
  "bubbles.devupdates.events.content": "Nuestro comunidad establecera un plan de interacción activa con la comunidad, mencionando estrategias como webinars educativos regulares y presencia en eventos clave del sector. Aunque no se especifican fechas para próximas sesiones AMA u otros eventos concretos en el documento, nuestro compromisoes mantener una comunicación fluida y educativa.",
  "bubbles.devupdates.events.date": "Fecha: 28 de abril de 2025",
  
  "bubbles.devupdates.technical.title": "Actualización Técnica: Auditoría de Smart Contracts",
  "bubbles.devupdates.technical.content": "Conforme a nuestro enfoque en la seguridad delineado en el whitepaper, existe el compromiso de que los contratos inteligentes de eDOP Token sean completadas las auditorías por firmas externas reconocidas (se mencionan ejemplos como CertiK o Hacken) previo a su lanzamiento. Se planea publicar dichos informes de auditoría en nuestra web para total transparencia con la comunidad",
  "bubbles.devupdates.technical.date": "Fecha: 28 de abril de 2025",
  
  "bubbles.devupdates.partnership.title": "Anuncio de Asociación Estratégica",
  "bubbles.devupdates.partnership.content": "Nuestro whitepaper establece la estrategia y la importancia de formar alianzas estratégicas para el crecimiento y la utilidad de eDOP Token, mencionando planes para colaborar con comercios, especialmente en mercados emergentes. No obstante, el documento fundacional no contiene anuncios específicos de asociaciones ya firmadas; describe la intención y el enfoque para buscarlas como parte de la hoja de ruta.",
  "bubbles.devupdates.partnership.date": "Fecha: 28 de abril de 2025",
  
  "bubbles.devupdates.previous.title": "Actualizaciones Anteriores",
  "bubbles.devupdates.previous.content1": "¡El whitepaper sirve como el plan maestro inicial y la presentación del proyecto eDOP Token. Por su naturaleza, las actualizaciones anteriores o los hitos ya completados desde su publicación aparecerán en los canales oficiales para información.",
  "bubbles.devupdates.previous.content2": "Para acceder a un archivo de noticias, avances y comunicados previos, por favor dirígete a las secciones de noticias/blog o a los canales históricos en redes sociales oficiales de eDOP. Vuelve aquí para ver todas nuestras actualizaciones anteriores!.",
  
  // Página Roadmap
  "roadmap.page.title": "Hoja de Ruta",
  "roadmap.page.subtitle": "Nuestra visión y objetivos para el futuro",

  // Roadmap Phases
  "roadmap.phase1.title": "Fase 1: Fundamentos y Lanzamiento",
  "roadmap.phase1.description": "Desarrollo de los fundamentos del token y lanzamiento de la preventa",
  "roadmap.phase1.items": [
    "Desarrollo y auditoría del Smart Contract",
    "Preventa del Token",
    "Construcción de la comunidad",
    "Lanzamiento del sitio web"
  ],

  "roadmap.phase2.title": "Fase 2: Lanzamiento al Mercado y Expansión",
  "roadmap.phase2.description": "Listado en DEX e inicio de campañas de marketing",
  "roadmap.phase2.items": [
    "Listado en DEX",
    "Campañas de marketing",
    "Asociaciones estratégicas",
    "Crecimiento de la comunidad"
  ],

  "roadmap.phase3.title": "Fase 3: Desarrollo de Productos",
  "roadmap.phase3.description": "Desarrollo de la plataforma de pagos e integración de billetera",
  "roadmap.phase3.items": [
    "Beta de la plataforma de pagos",
    "Integración de billetera",
    "Incorporación de comerciantes",
    "Auditorías de seguridad"
  ],

  "roadmap.phase4.title": "Fase 4: Expansión del Ecosistema",
  "roadmap.phase4.description": "Ampliación del ecosistema y nuevas funcionalidades",
  "roadmap.phase4.items": [
    "Lanzamiento de la App móvil",
    "Integración Cross-Chain",
    "Implementación de Gobernanza",
    "Nuevas alianzas"
  ],

  // Roadmap Status
  "roadmap.status.completed": "Completado",
  "roadmap.status.inProgress": "En Progreso",
  "roadmap.status.upcoming": "Próximamente",

  // Roadmap Additional Sections
  "roadmap.vision.title": "Nuestra Visión",
  "roadmap.vision.content": "Dar forma al futuro de los pagos digitales en la República Dominicana y más allá",

  "roadmap.updates.title": "Actualizaciones Recientes",
  "roadmap.updates.content": "Mantente informado sobre nuestro progreso",

  // Página de Vesting
  "vesting.page.title": "Plataforma de Vesting eDOP",
  
  // Página de Vesting - Burbujas
  "bubbles.vesting.platform.title": "Plataforma de Vesting eDOP",
  "bubbles.vesting.platform.content": "Los tokens destinados al equipo de desarrollo (un 5% del total) no se entregan todos de golpe. Primero, se bloquean completamente por 120 días. Luego, el equipo va recibiendo una pequeña porción cada mes (un 2% lineal de su asignación). Este proceso se llama vesting y asegura que el equipo siga comprometido con el proyecto eDOP Token a largo plazo.",
  
  "bubbles.vesting.emission.title": "Emisión Gradual de Tokens",
  "bubbles.vesting.emission.content": "eDOP controla la salida lenta de tokens con el vesting para el equipo y la distribución gradual de recompensas de staking (30% en 2 años). Esta emisión controlada busca evitar caídas bruscas del precio y alinear la circulación de tokens con el crecimiento del proyecto.",

  // Página de Staking
  "staking.page.title": "Plataforma de Staking eDOP",
  
  // Burbujas de Staking
  "bubbles.staking.platform.title": "Plataforma de Staking eDOP",
  "bubbles.staking.platform.content": "Es la función dentro de eDOP donde puedes bloquear tus tokens para apoyar el proyecto. A cambio de mantenerlos bloqueados allí, la plataforma te da premios (más eDOP Token).",
  
  "bubbles.staking.benefits.title": "Beneficios del Staking",
  "bubbles.staking.benefits.items": [
    "Ganas más eDOP: Recibes tokens extra como recompensa por bloquear los tuyos.",
    "Participas en decisiones: Te da la oportunidad de votar o influir en el futuro del proyecto.",
    "Apoyas al token: Ayudas a que el valor del token sea más estable a largo plazo."
  ],
  
  "bubbles.staking.rewards.title": "Recompensas",
  "bubbles.staking.rewards.content": "Podrás reclamar tus recompensas acumuladas una vez que la función de reclamación esté activa en la plataforma.",

  // Componente VestingBox4
  "vestingBox4.claimedTokens": "Tokens Reclamados",
  "vestingBox4.loading": "Cargando...",
  "vestingBox4.availableToClaim": "Disponibles para reclamar",
  "vestingBox4.processing": "Procesando...",
  "vestingBox4.claimTokens": "Reclamar Tokens",
  "vestingBox4.successTransaction": "¡Transacción Exitosa!",
  "vestingBox4.claimSuccess": "Has reclamado {{amount}} $eDOP con éxito.",
  "vestingBox4.viewTransaction": "Ver Transacción",
  "vestingBox4.close": "Cerrar",
  "vestingBox4.noTokensAvailable": "No tienes tokens disponibles para reclamar",
  "vestingBox4.claimError": "Error al reclamar tokens:",
  "vestingBox4.unknownError": "Error desconocido",

  // Componente VestingBox3
  "vestingBox3.calendar": "Calendario de Vesting",
  "vestingBox3.start": "Inicio",
  "vestingBox3.end": "Fin",
  "vestingBox3.cliffPeriod": "Período de Cliff",
  "vestingBox3.loading": "Cargando...",
  "vestingBox3.days": "días",
  "vestingBox3.progress": "Progreso",
  "vestingBox3.viewDetailedCalendar": "Ver Calendario Detallado",
  "vestingBox3.vestingStart": "Inicio del Vesting",
  "vestingBox3.cliffEnd": "Fin del Período de Cliff",
  "vestingBox3.vestingEnd": "Fin del Vesting",
  "vestingBox3.weeklyReleases": "Liberaciones Semanales",
  "vestingBox3.releaseDescription": "Después del período de cliff de 90 días, tus tokens se liberan semanalmente al 1% durante aproximadamente 2 años.",
  "vestingBox3.close": "Cerrar",

  // Componente VestingBox2
  "vestingBox2.nextRelease": "Próxima Liberación",
  "vestingBox2.noVesting": "Sin vesting",
  "vestingBox2.loading": "Cargando...",
  "vestingBox2.notScheduled": "No programado",
  "vestingBox2.availableNow": "Disponible ahora",
  "vestingBox2.days": "día(s)",
  "vestingBox2.hours": "hr(s)",
  "vestingBox2.minutes": "min",
  "vestingBox2.amountToRelease": "Cantidad a Liberar",
  "vestingBox2.claimAvailableTokens": "Reclamar Tokens Disponibles",

  // Componente VestingBox1
  "vestingBox1.yourVesting": "Tu Vesting",
  "vestingBox1.lockedTokens": "Tokens Bloqueados",
  "vestingBox1.viewDetails": "VER DETALLES",
  "vestingBox1.loading": "Cargando...",
  "vestingBox1.infoModal.title": "Información de Vesting",
  "vestingBox1.infoModal.content": "El vesting es un período durante el cual tus tokens se liberan gradualmente. Los \"Tokens Bloqueados\" representan la cantidad de tokens que aún no han sido liberados y no pueden ser reclamados todavía.",
  "vestingBox1.infoModal.understood": "Entendido",
  
  // Componente StakingBox4
  "stakingBox4.totalRewards": "RECOMPENSAS TOTALES",
  "stakingBox4.claimRewards": "Reclamar Recompensas",
  "stakingBox4.processing": "Procesando...",
  "stakingBox4.claimed": "Reclamado",
  "stakingBox4.success": "¡Éxito!",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Aceptar",
  "stakingBox4.noRewards": "No hay recompensas para reclamar",
  "stakingBox4.claimedSuccess": "¡Recompensas reclamadas exitosamente! Has recibido {{amount}} $eDOP",
  "stakingBox4.errorClaiming": "No se pudieron reclamar las recompensas",
  "stakingBox4.userRejected": "La transacción ha sido rechazada por el usuario",
  "stakingBox4.insufficientFunds": "Fondos insuficientes para realizar la transacción",
  "stakingBox4.contractRejection": "La transacción fue rechazada por el contrato",
  
  // Componente StakingBox3
  "stakingBox3.estimatedRewards": "RECOMPENSAS ESTIMADAS",
  "stakingBox3.rewardsDynamic": "• El porcentaje de recompensas es dinámico",
  "stakingBox3.monthly": "• Mensual = {{rate}}%",
  "stakingBox3.daily": "• Diario = {{rate}}%",
  
  // Componente StakingBox2
  "stakingBox2.poolPercentage": "% DEL POOL",
  "stakingBox2.stakedBalance": "SALDO STAKEADO",
  "stakingBox2.processing": "Procesando...",
  "stakingBox2.withdrawTokens": "Retirar Tokens",
  "stakingBox2.success": "¡Éxito!",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Aceptar",
  "stakingBox2.tokensWithdrawn": "Tokens retirados exitosamente",
  "stakingBox2.errorWithdrawing": "No se pudieron retirar los tokens",
  "stakingBox2.userRejected": "La transacción ha sido rechazada por el usuario",
  "stakingBox2.insufficientFunds": "Fondos insuficientes para realizar la transacción",
  "stakingBox2.contractRejection": "La transacción fue rechazada por el contrato",
  "stakingBox2.infoModal.title": "Porcentaje del Pool",
  "stakingBox2.infoModal.content": "Este porcentaje representa la proporción de tus tokens stakeados en relación al total de tokens en staking. Cuanto mayor sea tu porcentaje, mayor será la proporción de recompensas que recibirás.",
  "stakingBox2.infoModal.understood": "Entendido",
  
  // Componente StakingBox1
  "stakingBox1.stakedBalance": "SALDO STAKEADO",
  "stakingBox1.stakeable": "TU STAKEABLE",
  "stakingBox1.stakeNow": "STAKEA AHORA",
  "stakingBox1.success": "¡Éxito!",
  "stakingBox1.info": "INFO",
  "stakingBox1.accept": "Aceptar",
  "stakingBox1.connectWallet": "Por favor conecta tu wallet primero",
  "stakingBox1.enterValidAmount": "Por favor ingresa una cantidad válida",
  "stakingBox1.errorStaking": "Hubo un problema al stakear tus tokens",
  "stakingBox1.userRejected": "La transacción ha sido rechazada por el usuario",
  "stakingBox1.insufficientFunds": "Fondos insuficientes para realizar la transacción",
  "stakingBox1.contractRejection": "La transacción fue rechazada por el contrato",
  "stakingBox1.stakeTokens": "Stakear Tokens",
  "stakingBox1.processingTransaction": "Procesando Transacción",
  "stakingBox1.waitForStaking": "Por favor espera mientras se completa tu staking...",
  "stakingBox1.transactionSuccess": "¡Transacción Exitosa!",
  "stakingBox1.successStaked": "Has stakeado con éxito {{amount}} $eDOP",
  "stakingBox1.exit": "Salir",
  "stakingBox1.available": "Disponible: {{amount}}",
  "stakingBox1.confirm": "Aceptar",
  "stakingBox1.cancel": "Cancelar",
  
  // Componente StakingSupply
  "stakingSupply.title": "Suministro Total de Staking",
  "stakingSupply.totalSupply": "Suministro Total (Millones)",
  
  // Meses abreviados para gráficos
  "months.jan": "Ene",
  "months.feb": "Feb",
  "months.mar": "Mar",
  "months.apr": "Abr",
  "months.may": "May",
  "months.jun": "Jun",
  "months.jul": "Jul",
  "months.aug": "Ago",
  "months.sep": "Sep",
  "months.oct": "Oct",
  "months.nov": "Nov",
  "months.dec": "Dic",

  // Componente PresaleBox
  "presaleBox.buyMessage": "COMPRA TUS TOKEN $eDOP AHORA",
  "presaleBox.days": "Días",
  "presaleBox.hours": "Horas",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Seg",
  "presaleBox.presalePending": "Preventa por iniciar",
  "presaleBox.presaleCompleted": "Preventa finalizada",
  "presaleBox.stage": "Etapa {{current}} de {{total}}",
  "presaleBox.fundsRaised": "USDT Recaudado: ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "Tu Token eDOP Comprado: {{amount}}",
  "presaleBox.tokensStaked": "Su token $eDOP apostados = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Pagar con {{currency}}",
  "presaleBox.receive": "Recibir $eDOP",
  "presaleBox.maximum": "Máximo",
  "presaleBox.insufficientFunds": "No tienes suficiente {{currency}} para pagar esta transacción.",
  "presaleBox.buyWithBnb": "Comprar con {{symbol}}",
  "presaleBox.buyWithUsdt": "Comprar con {{symbol}}",
  "presaleBox.buyWithCard": "Comprar con Tarjeta",
  "presaleBox.goToDex": "Ir al DEX",
  "presaleBox.balance": "Balance en {{currency}}:",
  "presaleBox.connectWallet": "Conecta tu billetera",
  "presaleBox.reloadBnb": "¿No tienes suficiente BNB? Recarga aquí",
  "presaleBox.developedBy": "Desarrollado por",
  
  // Modal de información de PresaleBox
  "presaleBox.infoModal.title": "¡Atención!",
  "presaleBox.infoModal.tokensPurchased": "El total de tokens que has comprado son todos los tokens adquiridos con la billetera conectada. Esto incluye todos los tokens en stake y sin stake.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "Los $eDOP no reclamados que se compraron con ETH o ERC-20 USDT pueden ser utilizados en staking ahora. Tenga en cuenta que todos los tokens utilizados en staking anticipado pueden retirarse 7 días después de que se active la solicitud de tokens, lo que sucederá después de que haya concluido la preventa.",
  
  // Alertas de PresaleBox
  "presaleBox.alert.connectWallet": "Por favor conecta tu wallet primero",
  "presaleBox.alert.enterValidAmount": "Por favor ingresa una cantidad válida",
  "presaleBox.alert.presaleNotStarted": "La preventa inicia el 01 de Junio 2025. Por favor espera que la preventa inicie.",
  "presaleBox.alert.confirmInWallet": "Por favor confirma la transacción en tu wallet...",
  "presaleBox.alert.purchaseSuccess": "¡Compra exitosa! Has comprado {{amount}} tokens eDOP",
  "presaleBox.alert.paymentMethodNotSupported": "Método de pago no soportado",
  
  // Errores simplificados de PresaleBox
  "presaleBox.error.insufficientTokens": "No hay suficientes tokens disponibles en este momento. Por favor, intenta más tarde.",
  "presaleBox.error.userDenied": "Transacción rechazada. Debes confirmar la transacción en tu wallet para continuar.",
  "presaleBox.error.gas": "Error en el gas de la transacción. Asegúrate de tener suficiente BNB para cubrir las tarifas de gas.",
  "presaleBox.error.nonce": "Error de secuencia de transacciones. Intenta refrescar la página y volver a intentarlo.",
  "presaleBox.error.contractFailure": "La transacción falló. El contrato podría estar pausado o sin tokens disponibles.",
  "presaleBox.error.generic": "Error en la transacción. Por favor intente nuevamente más tarde.",
  
  // Mensajes de error para la preventa
  "presale.error.connectWalletFirst": "Por favor conecta tu wallet primero",
  "presale.error.contractNotReady": "El contrato de preventa no está listo",
  "presale.error.noSigner": "No se pudo obtener el signer. Por favor reconecta tu wallet.",
  "presale.error.priceChanged": "Error de precio: El precio ha cambiado. Por favor actualiza la página.",
  "presale.error.userRejected": "Transacción rechazada por el usuario",
  "presale.error.insufficientFunds": "Fondos insuficientes para completar la transacción",
  "presale.error.purchaseError": "Error en la compra: {{error}}",
  "presale.error.unknown": "Desconocido",
  "presale.error.usdtApprovalError": "Error en la aprobación de USDT",
  "presale.error.cannotClaimTokens": "No se puede reclamar tokens en este momento",
  
  // Mensajes de error para contratos
  "contracts.error.invalidConfig": "Contrato {{contractName}} no configurado correctamente",
  "contracts.error.initialization": "Error al inicializar el contrato {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "El contrato no está inicializado",
  "contracts.error.walletNotConnected": "Wallet no conectada. Por favor, conecta tu wallet para continuar",
  "contracts.error.transaction": "Error en la transacción: {{error}}",
  "errors.contractInitialization": "Error al inicializar contratos",
  
  // Errores de wallet
  "wallet.error.noMetamask": "MetaMask no está instalado",
  "wallet.error.noAccount": "No se pudo obtener la cuenta",
  "wallet.error.networkNotSupported": "Red no soportada",
  "wallet.error.connection": "Error al conectar wallet",
  "wallet.error.networkSwitch": "Error al cambiar de red",
  
  // Console messages - for developers only, not shown to users
  "console.contracts.initialized": "Contratos de preventa inicializados correctamente",
  "console.contracts.initError": "Error al inicializar contratos:",
  "console.tokens.availableError": "Error al cargar tokens disponibles:",
  "console.exchangeRates.error": "Error al obtener tasas de cambio:",
  "console.price.error": "Error al obtener precio del contrato:",
  "console.price.fromContract": "Precio obtenido del contrato:",
  "console.price.contractError": "Error al obtener precio del contrato:",
  "console.price.usingFallback": "Usando precio fallback:",
  "console.bnb.buying": "Comprando con BNB: {{amount}} BNB para obtener {{tokensToReceive}} tokens",
  "console.price.perToken": "Precio por token: {{price}} USDT",
  "console.signer.available": "Signer disponible: {{available}}",
  "console.account.current": "Cuenta actual: {{account}}",
  "console.bnb.success": "Compra con BNB exitosa:",
  "console.bnb.error": "Error al comprar con BNB:",
  "console.usdt.approving": "Aprobando gasto de USDT...",
  "console.price.fromContractUsdt": "Precio obtenido del contrato (USDT):",
  "console.price.contractErrorUsdt": "Error al obtener precio del contrato (USDT):",
  "console.price.usingFallbackUsdt": "Usando precio fallback (USDT):",
  "console.usdt.buying": "Comprando con USDT: {{amount}} USDT con precio {{price}} por token",
  "console.tokens.expected": "Tokens esperados: {{tokens}}",
  "console.usdt.success": "Compra con USDT exitosa:",
  "console.usdt.error": "Error al comprar con USDT:",
  "console.tokens.claimSuccess": "Tokens reclamados con éxito:",
  "console.tokens.claimError": "Error al reclamar tokens:",
  "console.purchases.error": "Error al obtener datos de compras:",

  // Ticker Messages
  "ticker.message1": "1️⃣ ¡Únete a la preventa de eDOP! 🚀 Aprovecha los precios exclusivos antes del lanzamiento. 🔥",
  "ticker.message2": "2️⃣ ¡eDOP revoluciona el mercado! 💎 Únete al ecosistema y asegura tu lugar en la nueva era digital. ⚡",
  "ticker.message3": "3️⃣ ¡Últimos días de la preventa de eDOP! ⏳ No te quedes fuera, obtén tus tokens antes de que sea tarde. 🎯",

  // Meta Tags
  "meta.description": "eDOP Token - La moneda del ecosistema financiero dominicano"
};

export default es;